/*
 * SPDX-FileCopyrightText: © 2024 Schneider Electric
 *
 * SPDX-License-Identifier: Apache-2.0
 */

@import url('../shared.css');

:host {
  display: inline-block;
}

[aria-disabled='true'] {
  opacity: var(--qds-theme-disabled);
  pointer-events: none;
}

.qds-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.qds-chip,
.qds-container,
.qds-label {
  max-width: inherit;
  min-width: inherit;
  width: inherit;
}

.qds-target {
  appearance: none;
  display: flex;
  border: none;
  padding: 0;
  background-color: transparent;
  color: inherit;
  cursor: pointer;
  pointer-events: auto;
  outline: none;

  &:disabled {
    pointer-events: none;
  }
}

.qds-alignment {
  display: flex;
  align-items: center;
}

.qds-cursor {
  cursor: pointer;
}

.qds-icon {
  flex-shrink: 0;
}

.qds-closable-chip,
.qds-container {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding-block: 0;
  user-select: none;
  border: var(--qds-control-border-width) solid var(--qds-theme-control-border);
  border-radius: var(--qds-control-rounded-border-radius);
  color: var(--qds-theme-control-text-standard);
  background-color: initial;
  appearance: none;
  box-sizing: border-box;
}

.qds-closable-chip {
  pointer-events: none;

  &:focus-within {
    outline: var(--qds-theme-focus-border) solid var(--qds-focus-border-width);
    outline-offset: var(--qds-focus-border-offset);
  }
}

.qds-container:hover {
  background-color: var(--qds-theme-interactive-background-hover);
}

.qds-checkbox:active ~ .qds-container,
.qds-closable-chip:has(.qds-target:active),
.qds-container.qds-pressed-state {
  background-color: var(--qds-theme-interactive-background-pressed);
}

.qds-checkbox {
  clip-path: inset(50%);
  margin: 0;
  position: absolute;

  &:focus-visible ~ .qds-container {
    outline: var(--qds-theme-focus-border) solid var(--qds-focus-border-width);
    outline-offset: var(--qds-focus-border-offset);
  }
}

[data-size='small'] {
  &.qds-closable-chip,
  &.qds-container {
    height: var(--qds-control-small-height);
    padding-inline: var(--qds-control-chip-small-padding-horizontal);
    gap: var(--qds-control-small-gap-internal);
  }

  &.qds-icon {
    --qds-experimental-icon-click-target-size: var(--qds-control-small-height);

    height: var(--qds-control-small-icon-size);
    width: var(--qds-control-small-icon-size);
  }

  &.qds-text {
    font: var(--qds-control-small-text);
    line-height: normal;
  }
}

[data-size='standard'] {
  &.qds-closable-chip,
  &.qds-container {
    height: var(--qds-control-standard-height);
    padding-inline: var(--qds-control-chip-standard-padding-horizontal);
    gap: var(--qds-control-standard-gap-internal);
  }

  &.qds-icon {
    --qds-experimental-icon-click-target-size: var(
      --qds-control-standard-height
    );

    height: var(--qds-control-standard-icon-size);
    width: var(--qds-control-standard-icon-size);
  }

  &.qds-text {
    font: var(--qds-control-standard-text);
    line-height: normal;
  }
}

[data-size='large'] {
  &.qds-closable-chip,
  &.qds-container {
    height: var(--qds-control-large-height);
    padding-inline: var(--qds-control-chip-large-padding-horizontal);
    gap: var(--qds-control-large-gap-internal);
  }

  &.qds-icon {
    --qds-experimental-icon-click-target-size: var(--qds-control-large-height);

    height: var(--qds-control-large-icon-size);
    width: var(--qds-control-large-icon-size);
  }

  &.qds-text {
    font: var(--qds-control-large-text);
    line-height: normal;
  }
}
